<template>
  <base-view edition="2024" />
</template>

<script>
import BaseView from "@/views/BaseView";

export default {
  components: {
    BaseView,
  },
};
</script>
